var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChurch(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.68852,
    height: 53.14754,
    viewBox: "0 0 30.68852 53.14754",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#92d3f5;}.cls-3{fill:#a57939;}.cls-4{fill:#d0cfce;}.cls-5{stroke-linejoin:round;}.cls-5,.cls-6{stroke-linecap:round;}.cls-5,.cls-6,.cls-7{fill:none;stroke:#000;stroke-width:2px;}.cls-6,.cls-7{stroke-miterlimit:10;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "emoji"
  }, /*#__PURE__*/React.createElement("g", {
    id: "color"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M22.16393,27.42623V14.20604l-6.21792-4.49297c-.34789-.2513-.85578-.2513-1.20367,0l-6.21775,4.49297v13.22019"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: ".80753 53 .85246 32.62759 15.38254 19.74123 29.84272 32.63757 29.83607 53 .80753 53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M19.60656,46.13174c0-3.28273-2.85437-5.22182-3.89139-5.81795-.23357-.13426-.50824-.13426-.74181,0-1.0371,.59613-3.89139,2.53521-3.89139,5.81795v6.04342c0,.45555,.34883,.82484,.77915,.82484h6.96629c.43032,0,.77915-.36928,.77915-.82484v-6.04342Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 15.34426,
    cy: 32.54098,
    r: 4.2623
  })), /*#__PURE__*/React.createElement("g", {
    id: "line"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.34426,20.06175l13.63934,12.10057v19.13276H1.70492v-19.13276l13.63934-12.10057m-.00008-2.01257c-.18814,0-.37636,.06726-.52793,.20178L.27969,31.14755c-.17765,.15754-.27969,.38668-.27969,.62767v20.39534c0,.45811,.36153,.82944,.80762,.82944H29.88091c.44609,0,.80762-.37133,.80762-.82944V31.77522c0-.24099-.10204-.47013-.27969-.62767l-14.53664-12.8966c-.15165-.13452-.33979-.20178-.52801-.20178h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M21.31148,20.60656v-7.25298l-5.44065-4.49297c-.30441-.2513-.7488-.2513-1.05321,0l-5.44056,4.49297v7.25298"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 15.34426,
    y1: 7.81967,
    x2: 15.34426,
    y2: 1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 12.36066,
    y1: 4.40984,
    x2: 18.32787,
    y2: 4.40984
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M19.60656,45.27928c0-3.28273-2.85437-5.22182-3.89139-5.81795-.23357-.13426-.50824-.13426-.74181,0-1.0371,.59613-3.89139,2.53521-3.89139,5.81795v6.04342c0,.45555,.34883,.82484,.77915,.82484h6.96629c.43032,0,.77915-.36928,.77915-.82484v-6.04342Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 15.34426,
    cy: 31.68852,
    r: 4.2623
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurch);
export default __webpack_public_path__ + "static/media/church.c5fb50265624012c047bdf4ed8f55493.svg";
export { ForwardRef as ReactComponent };